import React from 'react';
import { sound } from '../utils/sound';

interface ContentLink {
  title: string;
  video_url: string;
}

interface LinkSectionProps {
  videos: ContentLink[];
  onVideoClick: (url: string) => void;
  title?: string;
}

const LinkSection: React.FC<LinkSectionProps> = ({ videos, onVideoClick, title }) => {
  const isVideoFile = (url: string): boolean => {
    const videoExtensions = ['.mp4', '.webm', '.ogg', '.mov', '.avi', '.wmv', '.flv', '.mkv'];
    const urlLower = url.toLowerCase();
    return videoExtensions.some(ext => urlLower.endsWith(ext)) || urlLower.includes('.mp4') || urlLower.includes('.webm');
  };

  const handleLinkClick = (link: ContentLink) => {
    sound.clickOpen();

    if (isVideoFile(link.video_url)) {
      onVideoClick(link.video_url);
    } else {
      // Open page in new tab
      window.open(link.video_url, '_blank', 'noopener,noreferrer');
    }
  };

  if (!videos || videos.length === 0) {
    return null;
  }

  return (
    <div className="links-section">
      {title && <h3 className="links-section-title">{title}</h3>}
      {videos.map((link, index) => (
        <button
          key={index}
          className="link-button"
          onClick={() => handleLinkClick(link)}
        >
          <span className="link-label">{link.title}</span>
          <span className="link-icon">
            {'▶'}
          </span>
        </button>
      ))}
    </div>
  );
};

export default LinkSection;
